// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2c989d{color:var(--primary);position:absolute;top:0;left:0;right:0;border-top:1px dashed;opacity:.75}@media print{._2c989d{display:none}}._4aec6e{padding:3em 1rem 3em 0;min-width:var(--left-gutter);text-align:right;position:absolute;font-size:.75em;top:-3.75em;left:0;white-space:nowrap;background:linear-gradient(rgba(255, 255, 255, 0), var(--background) 30%, var(--background) 70%, rgba(255, 255, 255, 0))}.dark-theme ._4aec6e{background:linear-gradient(rgba(35, 40, 44, 0), #23282c 30%, #23282c 70%, rgba(35, 40, 44, 0))}", ""]);
// Exports
exports.locals = {
	"line": "_2c989d",
	"label": "_4aec6e"
};
module.exports = exports;
